/* eslint-disable @typescript-eslint/promise-function-async */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { StateOperator } from '@ngxs/store'
import { findIndices } from './utils/find-indices'
import { invalidIndexs } from './utils/invalid-indexes'
import { isArrayNumber } from './utils/is-array-number'
import { isObject } from './utils/is-object'
import { isPredicate } from './utils/is-predicate'
import { isStateOperator } from './utils/is-state-operator'
import { Predicate } from './utils/predicate.type'
import { ExistingState } from '@ngxs/store/operators'

/**
 * @param selector - Array of indices or a predicate function
 * that can be provided in `Array.prototype.findIndex`
 * @param operatorOrValue - New value under the `selector` index or a
 * function that can be applied to an existing value
 */
// eslint-disable-next-line @typescript-eslint/promise-function-async
export function updateManyItems<T>(
  selector: number[] | Predicate<T>,
  operatorOrValue: Partial<T> | StateOperator<T>
): any {
  return function updateItemsOperator(existing: readonly T[]) {
    let indices: any[] = []
    if (!selector || !operatorOrValue) {
      return existing
    }
    if (!existing) {
      return existing
    }
    if (isPredicate(selector)) {
      indices = findIndices(selector as any, existing)
    } else if (isArrayNumber(selector)) {
      indices = selector
    }

    if (invalidIndexs(indices, existing)) {
      return existing
    }
    let values: Record<number, T> = {}

    if (isStateOperator(operatorOrValue)) {
      values = indices.reduce(
        (acc: any, it: number) => ({
          ...acc,
          [it]: operatorOrValue(existing[it] as ExistingState<T>),
        }),
        {}
      )
    } else {
      values = indices.reduce(
        (acc: any, it: number) =>
          isObject(existing[it])
            ? { ...acc, [it]: { ...existing[it], ...operatorOrValue } }
            : { ...acc, [it]: operatorOrValue },
        {}
      )
    }

    const clone = [...existing]
    const keys = Object.keys(values).map((value) => Number(value))
    for (const i of keys) {
      clone[i] = values[i]
    }
    return clone
  }
}
